import { Dispatch } from "redux";
import {QuicktipReserveActionTypes, QuicktipReserveAction} from "../../types/Quicktip/quicktipReserveTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const reserveQuicktip = (data: any): any => {
    return async (dispatch: Dispatch<QuicktipReserveAction>) => {
        try {
            dispatch({ type: QuicktipReserveActionTypes.FETCH_QUICKTIP_RESERVE_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/quicktips/reserve`,
                data: data,
                withCredentials: false
            });
            dispatch({ type: QuicktipReserveActionTypes.FETCH_QUICKTIP_RESERVE_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuicktipReserveActionTypes.FETCH_QUICKTIP_RESERVE_DATA_ERROR, payload: errorPayload });
        }
    }
}
